<template>
    <div class="w-full flex-center ">
        <!-- 钱包 -->
        <!-- <div>
            <div>我的钱包</div>
            <div>
                <span>0.00</span>
                <span>CNY</span>
            </div>
            <div>
                账户余额（仅消费）
            </div>
        </div> -->
        <!-- 修改密码 -->
        <div class="bg-fff m-w-1200 w-full m-b-28 block">
            <div class="bg-fafafa p-12-20 title1">{{ $t('personal.change_password') }}</div>
            <div class="m-b-20">
                <div class=" col-lg-8  p-20-20-1">
                    <div class="p-0-0-20">
                        <div class="m-0-0-6 title5 f-w-600">{{ $t('personal.old_password') }}</div>
                        <div><el-input type="password" show-password v-model="password.oldVal"
                                :placeholder="$t('personal.please_enter_old_password')" /></div>
                    </div>
                    <div class="p-0-0-20">
                        <div class="m-0-0-6 title5 f-w-600">{{ $t('personal.new_password') }}</div>
                        <div class=""><el-input type="password" show-password v-model="password.newVal1"
                                :placeholder="$t('personal.please_enter_a_new_password')" /></div>
                    </div>
                    <div class="p-0-0-20">
                        <div class="m-0-0-6 title5 f-w-600">{{ $t('personal.new_password') }}</div>
                        <div class=""><el-input type="password" show-password v-model="password.newVal2"
                                :placeholder="$t('personal.please_enter_a_new_password')" /></div>
                    </div>
                    <div>
                        <div class="p-b-10 title3">{{ $t('prompt.pass_rule') }}</div>
                        <el-button type="primary" @click="changePass()" :loading="loading1">{{ $t('personal.save')}}</el-button>
                    </div>
                </div>
            </div>

        </div>
        <!-- 通知 -->
        <!-- <div>
            <div>通知</div>
            <div>
                <div>
                    <div>到期邮件提醒</div>
                    <div> <el-switch v-model="notice.expire" /> </div>
                </div>
                <div>
                    <div>流量邮件提醒</div>
                    <div> <el-switch v-model="notice.flow" /> </div>
                </div>
            </div>
        </div> -->
        <!-- 重置 -->
        <div class="bg-fff m-w-1200 w-full m-b-28 block">
            <div class="bg-fafafa p-12-20 title1">
                {{ $t('personal.reset_subscription_information') }}
            </div>
            <div class="m-b-20">
                <div class=" p-20-20-1">
                    <div class="m-0-0-16 p-12-20  f-color-855c0d bg-ffefd1 border-radius">
                        {{ $t('personal.reset_message') }}
                    </div>
                    <div><el-button type="danger" @click="reSetFlow()" :loading="loading2">{{ $t('personal.reset') }}</el-button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { changePassword, resetURL } from '@/utils/api'
import { ElNotification } from 'element-plus'
export default {
    setup() {
        const { t } = useI18n()
        return { t }
    },
    data() {
        return {
            password: {
                oldVal: '',
                newVal1: '',
                newVal2: ''
            },
            notice: {
                expire: true,
                flow: true
            },
            loading1: false,
            loading2:false,
        }
    }, 
    methods: {
        reSetFlow() {
            ElMessageBox.confirm(
                this.t('personal.change_subscription_info'),
                this.t('personal.sure_subscription'),
                {
                    confirmButtonText: this.t('orders.sure'),
                    cancelButtonText: this.t('orders.cancel'),
                    type: 'warning',
                }
            ).then(() => {
                //TODO 确认取消,像后端发送
                this.loading2 = true;
                resetURL().then(res => {
                    if (res !== undefined) {
                        if (res.data.code === 0) {
                            this.loading2 = false;
                            return ElNotification({
                                title: this.t('prompt.Success'),
                                message: res.data.msg,
                                type: 'success',
                            })
                        } else {
                            this.loading2 = false;
                            return ElNotification({
                                title: this.t('prompt.Mistake'),
                                message: res.data.msg,
                                type: 'error',
                            })
                        }
                    } else {
                        return ElNotification({
                            title: 'Error',
                            message: 'Network error',
                            type: 'error',
                        })
                    }
                })
            }).catch(() => {

            })
        },
        changePass() {
            this.loading1 = true;
            let passReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{6,24}$/;//eslint-disable-line
            let ispass1 = passReg.test(this.password.newVal1);
            if(ispass1 === false ){
                this.loading1 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.pass_rule_err'),
                    type: 'error',
                })
            }
            if (this.password.newVal1 !== this.password.newVal2) {
                this.loading1 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.password_diff'),
                    type: 'error',
                })
            }
            let param = {
                oldPwd: this.password.oldVal,
                newPwd: this.password.newVal1
            }
            changePassword(param).then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.loading1 = false;
                        sessionStorage.clear();
                        localStorage.clear();
                        this.$router.push('/login');
                        return ElNotification({
                            title: this.t('prompt.Success'),
                            message: this.t('prompt.password_change_success'),
                            type: 'success',
                        })
                    } else {
                        this.loading1 = false;
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            })
        }
    }
}
</script>

<style scoped></style>